import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import LandingScreen from './components/LandingScreen';
import Gallery from './components/Gallery';
import TeaserFooter from './components/TeaserFooter';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  const [showLanding, setShowLanding] = useState(true);

  useEffect(() => {
    // Check if user has already visited
    const visited = localStorage.getItem('renaissance_visited');
    if (visited === 'true') {
      setShowLanding(false);
    }
  }, []);

  const handleStart = () => {
    localStorage.setItem('renaissance_visited', 'true');
    setShowLanding(false);
  };

  return (
    <div className="App min-h-screen bg-[#F5F5F5]">
      <Toaster position="bottom-center" richColors />
      
      <AnimatePresence mode="wait">
        {showLanding ? (
          <LandingScreen onStart={handleStart} />
        ) : (
          <>
            <Gallery />
            <TeaserFooter />
          </>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;